import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";

const PropertyBankSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    account_name: z.string().min(1, "Account name is required"),
    account_number: z.string().min(1, "Account number is required"),
    bank_name: z.string().min(1, "Bank name is required"),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
})

export const ShowBankResponseSchema = BaseResponseSchema.extend({
    data: PropertyBankSchema,
})
export { PropertyBankSchema };

export type PropertyBank = z.infer<typeof ShowBankResponseSchema>;
export type PropertyBankData = z.infer<typeof PropertyBankSchema>;
